import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import './lib/amplify.js'; // configure Amplify before anything else mounts
import { startSessionListener } from './lib/auth.js';
import { isRefreshPage, runSilentRefresh } from './lib/refresh.js';
import { queryClient } from './lib/queryClient.js';
import { App } from './App.js';
import './index.css';

// A hidden frame renewing another app's session: renew, answer, render nothing.
if (isRefreshPage()) {
  void runSilentRefresh();
} else {
  startSessionListener();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
